import thumbnail from '../../../../images/report_thumbnail_tooling.png';
import { ReportV2Dto } from '../../../api';
import { DatasetSlugs } from '../../dataset';

const dimensionsWithDescriptions = [
    {
        key: 'role',
        title: 'Role in the marketing team',
        description: null,
    },
    {
        key: 'base_compensation',
        title: 'Base compensation',
        description: null,
    },
    {
        key: 'total_variable_compensation',
        title: 'Total variable compensation',
        description: null,
    },
    {
        key: 'compensation_increase',
        title: 'Compensation increase vs. previous compensation cycle',
        description: null,
    },
];

export const MarketingTeamCompensationReport: ReportV2Dto = {
    id: 'marketing_team_compensation',
    name: 'Marketing Team Compensation',
    tagline: null,
    description:
        'Understand compensation & compensation trends for different marketing roles relative to parameters of your company such as spend or revenue (obtained from Varos integrations)',
    category: 'marketing',
    dataset: DatasetSlugs.MARKETING_COMP,
    traits: [],
    tags: ['strategy', 'trends'],
    dependencies: [
        {
            kind: 'survey',
            dataset: DatasetSlugs.MARKETING_COMP,
        },
    ],
    thumbnail: {
        description: null,
        url: thumbnail,
    },
    images: [
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
    ],
    visualizations: dimensionsWithDescriptions.map((dimension) => ({
        key: dimension.key,
        kind: 'bar', // Assuming bar charts for all dimensions. Adjust as needed.
        name: dimension.title, // Name of the visualization
        description: dimension.description,
        aggregation: 'count', // Assuming count for all dimensions. Adjust as needed.
        breakdown: {
            keys: [dimension.key],
        },
    })),
};
